// Official primary and secondary colors for all 30 MLB franchises
const MLB_THEMES = [
  // AL East
  { id: 'bal', name: 'Baltimore Orioles',     primary: '#DF4601', secondary: '#000000' },
  { id: 'bos', name: 'Boston Red Sox',         primary: '#BD3039', secondary: '#0C2340' },
  { id: 'nyy', name: 'New York Yankees',       primary: '#003087', secondary: '#C4CED4' },
  { id: 'tb',  name: 'Tampa Bay Rays',         primary: '#092C5C', secondary: '#8FBCE6' },
  { id: 'tor', name: 'Toronto Blue Jays',      primary: '#134A8E', secondary: '#1D2D5C' },
  // AL Central
  { id: 'cws', name: 'Chicago White Sox',      primary: '#27251F', secondary: '#C4CED4' },
  { id: 'cle', name: 'Cleveland Guardians',    primary: '#00385D', secondary: '#E31937' },
  { id: 'det', name: 'Detroit Tigers',         primary: '#0C2340', secondary: '#FA4616' },
  { id: 'kc',  name: 'Kansas City Royals',     primary: '#004687', secondary: '#C09A5B' },
  { id: 'min', name: 'Minnesota Twins',        primary: '#002B5C', secondary: '#D31145' },
  // AL West
  { id: 'hou', name: 'Houston Astros',         primary: '#002D62', secondary: '#EB6E1F' },
  { id: 'laa', name: 'Los Angeles Angels',     primary: '#BA0021', secondary: '#003263' },
  { id: 'oak', name: 'Oakland Athletics',      primary: '#003831', secondary: '#EFB21E' },
  { id: 'sea', name: 'Seattle Mariners',       primary: '#0C2C56', secondary: '#005C5C' },
  { id: 'tex', name: 'Texas Rangers',          primary: '#003278', secondary: '#C0111F' },
  // NL East
  { id: 'atl', name: 'Atlanta Braves',         primary: '#CE1141', secondary: '#13274F' },
  { id: 'mia', name: 'Miami Marlins',          primary: '#00A3E0', secondary: '#FF6600' },
  { id: 'nym', name: 'New York Mets',          primary: '#002D72', secondary: '#FF5910' },
  { id: 'phi', name: 'Philadelphia Phillies',  primary: '#E81828', secondary: '#002D72' },
  { id: 'wsh', name: 'Washington Nationals',   primary: '#AB0003', secondary: '#14225A' },
  // NL Central
  { id: 'chc', name: 'Chicago Cubs',           primary: '#0E3386', secondary: '#CC3433' },
  { id: 'cin', name: 'Cincinnati Reds',        primary: '#C6011F', secondary: '#000000' },
  { id: 'mil', name: 'Milwaukee Brewers',      primary: '#12284B', secondary: '#FFC52F' },
  { id: 'pit', name: 'Pittsburgh Pirates',     primary: '#27251F', secondary: '#FDB827' },
  { id: 'stl', name: 'St. Louis Cardinals',    primary: '#C41E3A', secondary: '#0C2340' },
  // NL West
  { id: 'ari', name: 'Arizona Diamondbacks',   primary: '#A71930', secondary: '#E3D4AD' },
  { id: 'col', name: 'Colorado Rockies',       primary: '#33006F', secondary: '#C4CED4' },
  { id: 'lad', name: 'Los Angeles Dodgers',    primary: '#005A9C', secondary: '#EF3E42' },
  { id: 'sd',  name: 'San Diego Padres',       primary: '#2F241D', secondary: '#FFC425' },
  { id: 'sf',  name: 'San Francisco Giants',   primary: '#FD5A1E', secondary: '#27251F' },
];

export default MLB_THEMES;
